import AdsMappersFactory from '../../ads/Mappers/factory.js'
import AdsRepositoriesFactory from '../../ads/Repositories/factory.js'
import {SearchValueObjectsFactory} from '../../search/ValueObjects/factory.js'
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {UserAlertsMappersFactory} from '../Mappers/factory.js'
import UserAlertsRepositoriesFactory from '../Repositories/factory.js'
import {UserAlertsListValueObjectFactory} from '../ValueObjects/factory.js'
import GetSearchParamsRequestService from './GetSearchParamsRequestService.js'
import {GetUnseenSavedSearchMatchesService} from './GetUnseenSavedSearchMatchesService.js'
import {GetUserAlertsFilteredProvincesService} from './GetUserAlertsFilteredProvincesService.js'
import {GetUserAlertsService} from './GetUserAlertsService.js'

export class UserAlertsServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetUserAlertsService}
   * @property {hTTPUserAlertsRepository} repository
   */

  static getSearchParamsRequestService = ({config}) =>
    new GetSearchParamsRequestService({
      config,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject,
      searchRequestJSONToSearchParamsRequestJSONMapper:
        AdsMappersFactory.searchRequestJSONToSearchParamsRequestJSONMapper({
          config
        }),
      repository: AdsRepositoriesFactory.httpAdsRepository({
        config
      })
    })

  static getUserAlertsService = ({config}) =>
    new GetUserAlertsService({
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getUserNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })

  static getUserAlertsFilteredProvincesService = ({config}) =>
    new GetUserAlertsFilteredProvincesService({
      config,
      getUserAlertsService: UserAlertsServicesFactory.getUserAlertsService({
        config
      }),
      fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper:
        UserAlertsMappersFactory.fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper({config})
    })

  static getUnseenSavedSearchMatchesService = ({config}) =>
    new GetUnseenSavedSearchMatchesService({
      config,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      repository: UserAlertsRepositoriesFactory.hTTPUserAlertsRepository({
        config
      }),
      unseenSavedSearchMatchesVOFactory: UserAlertsListValueObjectFactory.unseenSavedSearchMatchesValueObject
    })
}
